import Helper from './Helper';

class NoLine {
  constructor() {
    const body = document.querySelector('body');
    this.marginal = document.querySelector('.ns-marginal');
    this.categoryPage = document.querySelector('.category-page');

    if ( this.categoryPage == null && this.marginal == null ) {
      Helper.addClass(body, 'no-line');
    }
  }
}
export default NoLine;
